import type { UndefinedOnPartialDeep } from 'type-fest';

import Text from '@ingka/text';
import type { DtoTimeWindowTransferringUnit } from '@repo/api-types/order-retrieval';
import { translate } from '@repo/phrase';

import { formatFulfillmentUnit } from '@/utils/services.utils';

interface Props {
    fulfillmentUnit: UndefinedOnPartialDeep<DtoTimeWindowTransferringUnit> | undefined;
}

const ArticleDeliveryFulfillingUnit = ({ fulfillmentUnit }: Props) => {
    const fulfillmentUnitText = formatFulfillmentUnit(fulfillmentUnit, ': ');

    if (!fulfillmentUnitText) {
        return <Text>{translate('services_article_delivery_fulfilling_unit_not_found')}</Text>;
    }

    return <Text>{fulfillmentUnitText}</Text>;
};

export default ArticleDeliveryFulfillingUnit;
